module.exports = __webpack_public_path__ + "static/media/card_bg_6.7dc59a63.png";